import { ApplicationConfigurationOptions } from '@/core/types';

export const ENV: ApplicationConfigurationOptions = {
  apiEndpoint: 'http://localhost:8080/',
  pageSize: 10,
  buildId: '8.0.9-rc.9',
  accountingMode: 'accounting',
  roles: [],
  excludedAttachmentTypes: [],
  enforceLatinName: true,
  authStorage: 'localStorage',
};
